import { createSelector } from 'reselect'
import { get, partialRight } from 'lodash'

export const selectValuationHistoryByHomeUuid = homeUuid =>
  createSelector(
    partialRight(get, `valuationHistory.${homeUuid}`),
    history => get(history, 'data')
  )

export const selectValuationGraphVisibilityByHomeUuid = homeUuid =>
  createSelector(
    selectValuationHistoryByHomeUuid(homeUuid),
    valuations => (valuations || []).length > 3
  )
